module.exports = __webpack_public_path__ + "img/account.f89ce5a8.svg";